module.exports = __webpack_public_path__ + "img/gy4.abd7b89c.png";